import { createApi } from '@reduxjs/toolkit/query/react'
import { appPortalBaseQuery } from '@/features/baseQuery'
import { UserMessage } from './user-messages.def.ts'

const USER_MESSAGES_BASE_URL = 'api/user-messages'

export const userMessagesApi = createApi({
  reducerPath: 'userMessagesApi',
  baseQuery: appPortalBaseQuery({
    baseUrl: import.meta.env.VITE_FINANCE_PORTAL_API_BASE_URL,
  }),
  tagTypes: ['UserMessages'],
  endpoints: (builder) => ({
    getUserMessages: builder.query<UserMessage[], void>({
      query: () => ({
        url: USER_MESSAGES_BASE_URL,
        method: 'GET',
      }),
      providesTags: ['UserMessages'],
    }),
    markUserMessageAsRead: builder.mutation<void, string>({
      query: (id) => ({
        url: `${USER_MESSAGES_BASE_URL}/${id}/read`,
        method: 'PATCH',
      }),
      invalidatesTags: ['UserMessages'],
    }),
    deleteUserMessage: builder.mutation<void, string>({
      query: (id) => ({
        url: `${USER_MESSAGES_BASE_URL}/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['UserMessages'],
    }),
  }),
})

export const {
  useGetUserMessagesQuery,
  useMarkUserMessageAsReadMutation,
  useDeleteUserMessageMutation,
} = userMessagesApi
